import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { makeObservable, observable, runInAction, reaction, computed, action } from "mobx";
import Base from "./Base";
import OrderInstructionModel from "./models/OrderInstructionModel";
import DPServices, { UserTypes } from "@dp/services";
import i18next from "i18next";
import PickupInfoModel from "./models/PickupInfoModel";
import PickupMethodModel from "./models/PickupMethodModel";
import ContactInfoModel from "./models/ContactInfoModel";
import LocationModel from "./models/LocationModel";
import BreadSticksModel from "./models/BreadSticksModel";
import { handle, Logger, toBoolean, getNoOfDaysBetween, extractFromFullName, getEnvProps, ORDER_TYPES, PlatformType, ERRORS, formatPhoneNumber } from "@dp/common";
import AgeConfirmModel from "./models/AgeConfirmModel";
import TimeModel from "./models/TimeModel";
import { OnlinePaymentTypes, FallbackReasonCode, PaymentMethods, PickupMethod, PaymentFlow, CheckoutDialogueCodes } from "../utils";
import moment from "moment-timezone";
import Errors, { ERROR_STRINGS } from "./Errors";
import { UnavailableItemsModel } from "./models";
var Checkout = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Checkout, _Base);

  var _super = _createSuper(Checkout); //Non observed values
  //Add all models for checkout here.


  function Checkout(rootStore) {
    var _this$rootStore, _this$rootStore$user;

    var _this;

    _classCallCheck(this, Checkout);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "cartOrder", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "formState", _descriptor2, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "orderInstructionModel", null);

    _defineProperty(_assertThisInitialized(_this), "pickupInfoModel", null);

    _defineProperty(_assertThisInitialized(_this), "pickupMethodModel", null);

    _defineProperty(_assertThisInitialized(_this), "contactInfoModel", null);

    _defineProperty(_assertThisInitialized(_this), "locationModel", null);

    _defineProperty(_assertThisInitialized(_this), "breadSticksModel", null);

    _defineProperty(_assertThisInitialized(_this), "timeModel", null);

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _defineProperty(_assertThisInitialized(_this), "payment", null);

    _defineProperty(_assertThisInitialized(_this), "unavailableItemsModel", null);

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "appAttributes", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "sessionAttributes", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "result", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "setPickResult", _descriptor6, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "ageConfirmModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "storeReactionsSetup", false);

    _initializerDefineProperty(_assertThisInitialized(_this), "_dialogueCode", _descriptor7, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "applyBagFee", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var cart;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return DPServices.Cart.applyBagFee();

            case 3:
              cart = _context.sent;

              if (cart !== null && cart !== void 0 && cart.order) {
                _this.orderInstructionModel.isBagFeeSelected = true;

                _this._processCartResponse(cart === null || cart === void 0 ? void 0 : cart.order);
              }

              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

              _this.appMessages.showError("Error", "Something went wrong, try again later.");

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "removeBagFee", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var cart;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return DPServices.Cart.removeBagFee();

            case 3:
              cart = _context2.sent;

              if (cart !== null && cart !== void 0 && cart.order) {
                _this.orderInstructionModel.isBagFeeSelected = false;

                _this._processCartResponse(cart === null || cart === void 0 ? void 0 : cart.order);
              }

              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);

              _this.appMessages.showError("Error", "Something went wrong, try again later.");

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    })));

    _this.rootStore = rootStore;
    _this.appMessages = rootStore.appMessages;
    _this.payment = rootStore.payment;
    _this.analyticsModel = (_this$rootStore = _this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$user = _this$rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : _this$rootStore$user.analyticsModel;
    _this.orderInstructionModel = new OrderInstructionModel(_this.rootStore.platformUtil);
    _this.pickupInfoModel = new PickupInfoModel(_this.rootStore.platformUtil);
    _this.pickupMethodModel = new PickupMethodModel();
    _this.contactInfoModel = new ContactInfoModel(_this.rootStore.platformUtil);
    _this.locationModel = new LocationModel();
    _this.breadSticksModel = new BreadSticksModel();

    if (_this.rootStore.menuList) {
      _this.timeModel = _this.rootStore.menuList.timeModel;
      _this.unavailableItemsModel = _this.rootStore.menuList.unavailableItemsModel;
    } else {
      _this.timeModel = new TimeModel(_this.rootStore.platformUtil);
      _this.unavailableItemsModel = new UnavailableItemsModel(_this.rootStore.platformUtil);
    }

    _this.ageConfirmModel = new AgeConfirmModel(_this.rootStore.platformUtil);
    _this.formState = {
      submitCount: 0,
      apiFiredCount: 0,
      isFailed: false,
      isSubmitting: false,
      isSuccess: false
    };
    _this.storeReactionsSetup = false;
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Checkout, [{
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.orderInstructionModel.specialInstructions = "";
                this.ageConfirmModel.isOrderContainAlcoholItem = false;
                this.dialogueCode = null;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this;

      if (this.storeReactionsSetup) {
        return;
      } //app-init


      reaction(function () {
        return {
          appAttributes: _this2.rootStore.common.appAttributes
        };
      }, function (data) {
        _this2._processAppAttributes(data.appAttributes);
      });
      reaction(function () {
        return {
          submitCount: _this2.formState.submitCount
        };
      }, function (data) {
        var isSubmitted = data.submitCount > 0;
        _this2.payment.formSubmitted = isSubmitted;
      }); //session-details

      reaction(function () {
        return {
          sessionDetails: _this2.rootStore.user.sessionDetails
        };
      }, function (data) {
        _this2._processSessionDetails(data.sessionDetails);
      }); //times call

      reaction(function () {
        return {
          cartOrder: _this2.cartOrder
        };
      }, function (data) {
        var _data$cartOrder;

        if ((_data$cartOrder = data.cartOrder) !== null && _data$cartOrder !== void 0 && _data$cartOrder.restaurantId) {
          _this2.fetchTimes();
        }
      });
      reaction(function () {
        return {
          isSmartPaySelected: _this2.payment.isSmartPaySelected
        };
      }, function (data) {
        _this2.contactInfoModel.isSmartPaySelected = data.isSmartPaySelected;
      }); //user-profile

      reaction(function () {
        return {
          userProfile: _this2.rootStore.user.userProfile,
          isLoggedIn: _this2.rootStore.user.isLoggedIn
        };
      }, function (data) {
        if (data.isLoggedIn) {
          _this2._processUserProfile(data.isLoggedIn, data.userProfile);
        }
      }); //PhoneNumber position based on pickup method

      reaction(function () {
        return {
          pickupMethod: _this2.pickupMethodModel.pickupMethod
        };
      }, function (data) {
        _this2._processPickupMethod(data.pickupMethod);
      }); //isValid reactions for mobile accordion

      reaction(function () {
        return {
          isOrderAndPickupStepValid: _this2.orderInstructionModel.isValid && _this2.pickupInfoModel.isValid
        };
      }, function (data) {
        runInAction(function () {
          _this2.rootStore.common.accordionModel.model.orderAndPickupStep.isValid = data.isOrderAndPickupStepValid;
        });
      });
      this.payment.creditCardInfo.registerOnCCNameChangeHandler(function (ccFirstName, ccLastName) {
        var isLoggedIn = _this2.rootStore.user.isLoggedIn;

        if (!isLoggedIn) {
          var contactInfoFirstName = _this2.contactInfoModel.fName;
          var contactInfoLastName = _this2.contactInfoModel.lName;

          if (ccFirstName && !contactInfoFirstName) {
            _this2.contactInfoModel.fName = ccFirstName;
          }

          if (ccLastName && !contactInfoLastName) {
            _this2.contactInfoModel.lName = ccLastName;
          }
        }
      });
      this.storeReactionsSetup = true;
      reaction(function () {
        return {
          isApplePaySelected: _this2.payment.activePaymentTab === PaymentMethods.ONLINE && _this2.payment.activeOtherOptionTab === OnlinePaymentTypes.APPLE_PAY
        };
      }, function (data) {
        _this2.contactInfoModel.isApplePaySelected = data.isApplePaySelected;
      });
    }
  }, {
    key: "_processAppAttributes",
    value: function _processAppAttributes(appAttributes) {
      var _this3 = this;

      runInAction(function () {
        _this3.appAttributes = appAttributes;
      });

      if (appAttributes) {
        var _appAttributes$config; // Occation information for togo delivery order


        this.orderInstructionModel.occasionInfo = appAttributes === null || appAttributes === void 0 ? void 0 : appAttributes.deliveryOccasion; // This has been moved

        this.contactInfoModel.setAppAttributes(appAttributes);
        this.orderInstructionModel.setAppAttributes(appAttributes);
        this.pickupInfoModel.setAppAttributes(appAttributes);
        this.unavailableItemsModel.setAppAttributes(appAttributes);
        this.breadSticksModel.setAppAttributesData(appAttributes);
        runInAction(function () {
          _this3.appAttributes = appAttributes;
        });

        if (appAttributes.currentConceptCode) {
          //this.orderInstructionModel.includeSilverware = "yes";
          runInAction(function () {
            _this3.rootStore.common.accordionModel.model.orderAndPickupStep.isValid = _this3.orderInstructionModel.isValid && _this3.pickupInfoModel.isValid;
          });
        }

        var isPaypalToGoEnabled = appAttributes === null || appAttributes === void 0 ? void 0 : (_appAttributes$config = appAttributes.configs) === null || _appAttributes$config === void 0 ? void 0 : _appAttributes$config.isPaypalToGoEnabled;

        if (this.payment) {
          this.payment.requestPhoneNumberFromAppleOrGooglePay = true;
          this.payment.requestShippingFieldsFromAppleOrGooglePay = false;
          this.payment.creditCardInfo.fullAVSEnabled = false;
          this.payment.isPayPalEnabled = isPaypalToGoEnabled === "true";
          var configs = appAttributes.configs;
          this.payment.gratuityModel.minTipPercentage = parseInt(configs.min_tip_percentage) || 0;
          this.payment.gratuityModel.maxTipPercentage = parseInt(configs.max_tip_percentage) || 25;
          this.payment.gratuityModel.tipLabelStep = parseInt(configs.max_tip_label_step) || 5;
        }
      }

      this.timeModel.setAppAttributes(this.appAttributes); // TODO: Change this.
    }
  }, {
    key: "_processSessionDetails",
    value: function _processSessionDetails(sessionDetails) {
      var _this4 = this;

      if (sessionDetails) {
        runInAction(function () {
          var _sessionDetails$succe;

          _this4.locationModel.locationDateTime.actualPickupDateTime = (_sessionDetails$succe = sessionDetails.successResponse.sessionContext) === null || _sessionDetails$succe === void 0 ? void 0 : _sessionDetails$succe.actualPickupDateTime;
        });
        this.orderInstructionModel.setSessionDetails(sessionDetails);
        runInAction(function () {
          _this4.locationModel.sessionDetails = sessionDetails;
        });
        this.timeModel.setSessionDetails(sessionDetails);
      }
    }
  }, {
    key: "_processUserProfile",
    value: function _processUserProfile(isLoggedIn, userProfile) {
      if (isLoggedIn && userProfile) {
        var _userProfile$defaultP;

        this.contactInfoModel.fName = userProfile.firstName;
        this.contactInfoModel.lName = userProfile.lastName;
        this.contactInfoModel.emailId = userProfile.login;
        var defaultPhoneNumber = (_userProfile$defaultP = userProfile.defaultPhone) === null || _userProfile$defaultP === void 0 ? void 0 : _userProfile$defaultP.phone;
        this.contactInfoModel.phoneNumber = formatPhoneNumber(defaultPhoneNumber);
        this.pickupInfoModel.curbSideMobile = formatPhoneNumber(defaultPhoneNumber);
        this.payment.creditCardInfo.fullAVSEnabled = true;
      }
    }
  }, {
    key: "_processPickupMethod",
    value: function _processPickupMethod(pickupMethod) {
      if (pickupMethod === PickupMethod.CARSIDE) {
        this.pickupInfoModel.openColor = false;
        this.pickupInfoModel.isCurbsidePickupSelected = true;
        this.payment.requestPhoneNumberFromAppleOrGooglePay = false;
        this.contactInfoModel.phoneNumberVisible = false;
      } else {
        this.contactInfoModel.phoneNumberVisible = true;
        this.pickupInfoModel.isCurbsidePickupSelected = false;
        this.payment.requestPhoneNumberFromAppleOrGooglePay = true;
      }
    }
  }, {
    key: "_processCartResponse",
    value: function () {
      var _processCartResponse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(order) {
        var orderType, restaurantId, _latLngArr$, _latLngArr$2, restaurantDetail, address, restPhoneNumber, restaurantName, breadCountEnable, phoneNumber, latLngArr, zipValue, location;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!order) {
                  _context4.next = 23;
                  break;
                }

                this.payment.orderPriceInfo = order === null || order === void 0 ? void 0 : order.priceInfo;
                this.payment.tippableAmount = order === null || order === void 0 ? void 0 : order.tippableAmount;
                this.payment.couponModel.appliedCouponCode = order === null || order === void 0 ? void 0 : order.couponDescription;
                this.payment.couponModel.couponDiscount = order === null || order === void 0 ? void 0 : order.couponDiscount;
                this.cartOrder = order;
                this.payment.subTotalWithoutItemDiscount = order.subTotalWithoutItemDiscount;
                this.breadSticksModel.cartItems = order.commerceItems;
                orderType = this.cartOrder.orderType;
                this.pickupInfoModel.isPickupEligible = orderType !== ORDER_TYPES.CATERING_DELIVERY; // Delivery Order

                restaurantId = order === null || order === void 0 ? void 0 : order.restaurantId;

                if (!restaurantId) {
                  _context4.next = 23;
                  break;
                }

                _context4.next = 14;
                return DPServices.Restaurant.getRestaurantDetailsById(restaurantId);

              case 14:
                restaurantDetail = _context4.sent;
                this.analyticsModel.setRestaurantDetailData(restaurantDetail);
                address = restaurantDetail.address, restPhoneNumber = restaurantDetail.restPhoneNumber, restaurantName = restaurantDetail.restaurantName, breadCountEnable = restaurantDetail.breadCountEnable;
                phoneNumber = restPhoneNumber[0]; //not safe

                latLngArr = address.longitudeLatitude ? address.longitudeLatitude.split(",") : [];
                zipValue = address.zipCode ? address.zipCode.substring(0, 5) : null;
                location = {
                  restaurantName: restaurantName,
                  address1: address.address1,
                  address2: address.address2,
                  city: address.city,
                  state: address.state,
                  zip: zipValue,
                  phoneNumber: formatPhoneNumber(phoneNumber.Phone),
                  lat: latLngArr && latLngArr.length > 1 ? (_latLngArr$ = latLngArr[0]) === null || _latLngArr$ === void 0 ? void 0 : _latLngArr$.trim() : null,
                  lng: latLngArr && latLngArr.length > 1 ? (_latLngArr$2 = latLngArr[1]) === null || _latLngArr$2 === void 0 ? void 0 : _latLngArr$2.trim() : null
                };
                this.locationModel.location = location;
                this.breadSticksModel.isBreadCountEnabled = breadCountEnable;

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _processCartResponse(_x) {
        return _processCartResponse2.apply(this, arguments);
      }

      return _processCartResponse;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this$rootStore2,
            _this$rootStore2$user,
            _this$rootStore3,
            _this$rootStore3$user,
            _this5 = this;

        var _yield$handle, _yield$handle2, err, sessionAttributes, _yield$handle3, _yield$handle4, cartDetailsErr, cartDetailsResponse;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.reset();

              case 2:
                _context6.next = 4;
                return handle(this.rootStore.platformUtil.hydrateUsingLocalStorage("CHECKOUT_CONTACT_INFO", this.contactInfoModel));

              case 4:
                _context6.next = 6;
                return handle(this.rootStore.platformUtil.hydrateUsingLocalStorage("CHECKOUT_PICKUP_INFO", this.pickupInfoModel));

              case 6:
                _context6.next = 8;
                return handle(this.rootStore.platformUtil.hydrateUsingSessionStorage(["ORDER_INS_INFO"].join("-"), this.orderInstructionModel));

              case 8:
                _context6.next = 10;
                return handle(this.rootStore.platformUtil.hydrateUsingSessionStorage(["CHECKOUT_PICKUP_METHOD"].join("-"), this.pickupMethodModel));

              case 10:
                this.payment = this.rootStore.payment;
                this.payment.flow = PaymentFlow.CHECKOUT;
                this.appMessages = this.rootStore.appMessages; //IMPORTANT: common store is already initialized before Checkout store

                this._processAppAttributes(this.rootStore.common.appAttributes);

                this._processSessionDetails(this.rootStore.user.sessionDetails);

                this._processUserProfile((_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$user = _this$rootStore2.user) === null || _this$rootStore2$user === void 0 ? void 0 : _this$rootStore2$user.isLoggedIn, (_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$user = _this$rootStore3.user) === null || _this$rootStore3$user === void 0 ? void 0 : _this$rootStore3$user.userProfile);

                this._processPickupMethod(this.pickupMethodModel.pickupMethod);

                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
                  this.orderInstructionModel.showSpecialInstructions = true;
                } else {
                  this.orderInstructionModel.showSpecialInstructions = false;
                } //sessioninit api


                _context6.next = 20;
                return handle(DPServices.Common.getSessionAttributes());

              case 20:
                _yield$handle = _context6.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                sessionAttributes = _yield$handle2[1];

                if (err) {
                  this.appMessages.showError("Checkout", "Something went wrong. Please try again.", null, {
                    undismissible: true,
                    okBtnText: "Go Back",
                    okBtnOnClick: function okBtnOnClick() {
                      _this5.redirectToEmptyCartPage();
                    }
                  });
                } else {
                  if (sessionAttributes) {
                    runInAction(function () {
                      if (!(sessionAttributes !== null && sessionAttributes !== void 0 && sessionAttributes.dardenSessionContext.checkCreated)) {
                        _this5.redirectToEmptyCartPage();
                      } else {
                        _this5.sessionAttributes = sessionAttributes;
                        var isCurbSideToGoAvailable = sessionAttributes.isCurbSideToGoAvailable,
                            isInRestaurantPickupAvailable = sessionAttributes.isInRestaurantPickupAvailable,
                            orderLockedForFraudSuspicion = sessionAttributes.orderLockedForFraudSuspicion,
                            isCurbsideNotificationEnabled = sessionAttributes.isCurbsideNotificationEnabled; //this.timeModel.setSessionAttributes(sessionAttributes);

                        if (!_this5.payment.gratuityModel.selectedTipPercentage) {
                          _this5.payment.gratuityModel.selectedTipPercentage = (sessionAttributes === null || sessionAttributes === void 0 ? void 0 : sessionAttributes.defaultTipPercentage) || 15;
                        }

                        if (sessionAttributes !== null && sessionAttributes !== void 0 && sessionAttributes.dardenSessionContext.isCartContainsAlcoholItem) {
                          _this5.ageConfirmModel.isOrderContainAlcoholItem = true;
                        }

                        _this5.payment.allowedPaymentMethods = _this5.sessionAttributes.paymentMethods;

                        if (orderLockedForFraudSuspicion || sessionAttributes.dardenSessionContext.orderLockedForFraudSuspicion) {
                          _this5.payment.isCCPaymentDisabled = true;
                        }

                        _this5.handleCurbsideAvailability(isCurbSideToGoAvailable, isInRestaurantPickupAvailable, isCurbsideNotificationEnabled);

                        _this5.orderInstructionModel.setSessionAttributes(sessionAttributes);

                        if (sessionAttributes.deliveryGroup) {
                          var _sessionAttributes$de = sessionAttributes.deliveryGroup,
                              address1 = _sessionAttributes$de.address1,
                              address2 = _sessionAttributes$de.address2,
                              city = _sessionAttributes$de.city,
                              state = _sessionAttributes$de.state,
                              postalCode = _sessionAttributes$de.postalCode;
                          var deliveryAddress = {
                            address1: address1,
                            address2: address2,
                            city: city,
                            state: state,
                            postalCode: postalCode
                          };
                          _this5.locationModel.deliveryAddress = deliveryAddress;
                        }
                      }
                    });
                  }
                }

                _context6.next = 27;
                return handle(DPServices.Cart.getCartDetails());

              case 27:
                _yield$handle3 = _context6.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                cartDetailsErr = _yield$handle4[0];
                cartDetailsResponse = _yield$handle4[1];

                if (cartDetailsErr) {
                  this.appMessages.showError("Cart", "Invalid State. Please Go Back.", null, {
                    undismissible: true,
                    okBtnText: "Go Back",
                    okBtnOnClick: function okBtnOnClick() {
                      _this5.redirectToEmptyCartPage();
                    }
                  });
                } else {
                  runInAction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                    var _cartDetailsResponse$;

                    var order;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            order = cartDetailsResponse === null || cartDetailsResponse === void 0 ? void 0 : (_cartDetailsResponse$ = cartDetailsResponse.successResponse) === null || _cartDetailsResponse$ === void 0 ? void 0 : _cartDetailsResponse$.order;

                            if (order) {
                              _this5._processCartResponse(order);

                              _this5.determinePaymentMethods();
                            }

                          case 2:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  })));
                }

              //this.pickupTimeApiHander(false);

              case 32:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "determinePaymentMethods",
    value: function determinePaymentMethods() {
      var _this$sessionAttribut,
          _this6 = this;

      var sessionPaymentFlagInfo = (_this$sessionAttribut = this.sessionAttributes) === null || _this$sessionAttribut === void 0 ? void 0 : _this$sessionAttribut.paymentFlagInfo;
      var appAttributes = this.appAttributes;
      var appPaymentFlagInfo = appAttributes.paymentFlagInfo;
      var orderType = this.cartOrder.orderType;

      var _getEnvProps = getEnvProps(),
          NODE_ENV = _getEnvProps.NODE_ENV;

      var DEV_NODE_ENV = NODE_ENV === "development";

      if (orderType === ORDER_TYPES.CATERING_DELIVERY) {
        this.payment.isGooglePayEnabled = false;
        this.payment.isApplePayEnabled = false;
      } else {
        var _appPaymentFlagInfo$w, _appPaymentFlagInfo$w2, _sessionPaymentFlagIn, _sessionPaymentFlagIn2, _appPaymentFlagInfo$a, _appPaymentFlagInfo$g;

        var isApplePayTogoEnabledAtSiteLevel = DEV_NODE_ENV ? true : (_appPaymentFlagInfo$w = appPaymentFlagInfo === null || appPaymentFlagInfo === void 0 ? void 0 : appPaymentFlagInfo.webApplePay) !== null && _appPaymentFlagInfo$w !== void 0 ? _appPaymentFlagInfo$w : true;
        var isGooglePayTogoEnabledAtSiteLevel = DEV_NODE_ENV ? true : (_appPaymentFlagInfo$w2 = appPaymentFlagInfo === null || appPaymentFlagInfo === void 0 ? void 0 : appPaymentFlagInfo.webGooglePay) !== null && _appPaymentFlagInfo$w2 !== void 0 ? _appPaymentFlagInfo$w2 : true;
        var isApplePayTogoEnabledAtSessionLevel = DEV_NODE_ENV ? true : (_sessionPaymentFlagIn = sessionPaymentFlagInfo === null || sessionPaymentFlagInfo === void 0 ? void 0 : sessionPaymentFlagInfo.webApplePay) !== null && _sessionPaymentFlagIn !== void 0 ? _sessionPaymentFlagIn : true;
        var isGooglePayTogoEnabledAtSessionLevel = DEV_NODE_ENV ? true : (_sessionPaymentFlagIn2 = sessionPaymentFlagInfo === null || sessionPaymentFlagInfo === void 0 ? void 0 : sessionPaymentFlagInfo.webGooglePay) !== null && _sessionPaymentFlagIn2 !== void 0 ? _sessionPaymentFlagIn2 : true;
        var currentPickupTimestamp = this.timeModel.currentAPIPickupTime;
        var applePayPickupNoOfDaysThreshold = (_appPaymentFlagInfo$a = appPaymentFlagInfo === null || appPaymentFlagInfo === void 0 ? void 0 : appPaymentFlagInfo.applePayThresholdDays) !== null && _appPaymentFlagInfo$a !== void 0 ? _appPaymentFlagInfo$a : 0;
        var googlePayPickupNoOfDaysThreshold = (_appPaymentFlagInfo$g = appPaymentFlagInfo === null || appPaymentFlagInfo === void 0 ? void 0 : appPaymentFlagInfo.googlePayThresholdDays) !== null && _appPaymentFlagInfo$g !== void 0 ? _appPaymentFlagInfo$g : 0;
        var daysDiff = getNoOfDaysBetween(moment().toDate(), moment(currentPickupTimestamp).toDate());
        var applePayWithinThreshold = daysDiff <= applePayPickupNoOfDaysThreshold;
        var googlePayWithinThreshold = daysDiff <= googlePayPickupNoOfDaysThreshold;

        if (applePayWithinThreshold && isApplePayTogoEnabledAtSessionLevel && isApplePayTogoEnabledAtSiteLevel) {
          if (googlePayWithinThreshold && isGooglePayTogoEnabledAtSessionLevel && isGooglePayTogoEnabledAtSiteLevel) {
            // Both Available
            this.rootStore.refreshInProgress = true;
            Promise.all([this.rootStore.platformUtil.canMakeApplePayPayment(this.payment.applePayPaymentMerchantId), this.rootStore.platformUtil.canMakeGooglePayPayment(this.payment.googlePayIsReadyToPayRequest)]).then(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 2),
                  canUseApplePay = _ref5[0],
                  canUseGooglePay = _ref5[1];

              _this6.rootStore.refreshInProgress = false;
              _this6.payment.isGooglePayEnabled = canUseGooglePay;
              _this6.payment.isApplePayEnabled = canUseApplePay;

              if (_this6.payment.activeOtherOptionTab === OnlinePaymentTypes.NONE) {
                if (canUseApplePay) {
                  _this6.payment.activeOtherOptionTab = OnlinePaymentTypes.APPLE_PAY;
                } else {
                  if (canUseGooglePay) {
                    _this6.payment.activeOtherOptionTab = OnlinePaymentTypes.GOOGLE_PAY;
                  } else {
                    if (!_this6.rootStore.isMobile) {
                      _this6.payment.activeOtherOptionTab = OnlinePaymentTypes.CREDIT_CARD;
                    }
                  }
                }
              }
            });
          } else {
            // Only Apple Pay
            this.rootStore.refreshInProgress = true;
            Promise.all([this.rootStore.platformUtil.canMakeApplePayPayment(this.payment.applePayPaymentMerchantId)]).then(function (_ref6) {
              var _ref7 = _slicedToArray(_ref6, 1),
                  canUseApplePay = _ref7[0];

              _this6.rootStore.refreshInProgress = false;
              _this6.payment.isApplePayEnabled = canUseApplePay;
              _this6.payment.isGooglePayEnabled = false;

              if (_this6.payment.activeOtherOptionTab === OnlinePaymentTypes.NONE || _this6.payment.activeOtherOptionTab === OnlinePaymentTypes.GOOGLE_PAY) {
                _this6.payment.activeOtherOptionTab = canUseApplePay ? OnlinePaymentTypes.APPLE_PAY : _this6.rootStore.isMobile ? OnlinePaymentTypes.NONE : OnlinePaymentTypes.CREDIT_CARD;
              }
            });
          }
        } else {
          if (googlePayWithinThreshold && isGooglePayTogoEnabledAtSessionLevel && isGooglePayTogoEnabledAtSiteLevel) {
            // Only Google Play
            this.rootStore.refreshInProgress = true;
            Promise.all([this.rootStore.platformUtil.canMakeGooglePayPayment(this.payment.googlePayIsReadyToPayRequest)]).then(function (_ref8) {
              var _ref9 = _slicedToArray(_ref8, 1),
                  canUseGooglePay = _ref9[0];

              _this6.rootStore.refreshInProgress = false;
              _this6.payment.isApplePayEnabled = false;
              _this6.payment.isGooglePayEnabled = canUseGooglePay;

              if (_this6.payment.activeOtherOptionTab === OnlinePaymentTypes.NONE || _this6.payment.activeOtherOptionTab === OnlinePaymentTypes.APPLE_PAY) {
                _this6.payment.activeOtherOptionTab = canUseGooglePay ? OnlinePaymentTypes.GOOGLE_PAY : _this6.rootStore.isMobile ? OnlinePaymentTypes.NONE : OnlinePaymentTypes.CREDIT_CARD;
              }
            });
          } else {
            //Neither
            this.payment.isApplePayEnabled = false;
            this.payment.isGooglePayEnabled = false;

            if (this.payment.activeOtherOptionTab === OnlinePaymentTypes.NONE || this.payment.activeOtherOptionTab === OnlinePaymentTypes.GOOGLE_PAY || this.payment.activeOtherOptionTab === OnlinePaymentTypes.APPLE_PAY) {
              var _this$payment, _this$payment$creditC;

              this.payment.activeOtherOptionTab = this.rootStore.isMobile || (_this$payment = this.payment) !== null && _this$payment !== void 0 && (_this$payment$creditC = _this$payment.creditCards) !== null && _this$payment$creditC !== void 0 && _this$payment$creditC.length ? OnlinePaymentTypes.NONE : OnlinePaymentTypes.CREDIT_CARD;
            }
          }
        }
      }
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "applyCoupon",
    value: function () {
      var _applyCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this7 = this;

        var couponModel, couponCode, _yield$handle5, _yield$handle6, err, couponResp;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                couponModel = this.payment.couponModel;
                couponCode = couponModel.couponCode;
                couponModel.isCouponLoading = true;
                _context8.next = 5;
                return handle(DPServices.Cart.applyCouponCode(couponCode === null || couponCode === void 0 ? void 0 : couponCode.trim()));

              case 5:
                _yield$handle5 = _context8.sent;
                _yield$handle6 = _slicedToArray(_yield$handle5, 2);
                err = _yield$handle6[0];
                couponResp = _yield$handle6[1];

                if (!err) {
                  if (couponResp) {
                    runInAction(function () {
                      couponModel.isCouponValid = true;
                      couponModel.couponCode = ""; // Coupon Code will be present in the cart detail

                      var order = couponResp.order;

                      _this7._processCartResponse(order); // analyticd event


                      _this7.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "applyCoupon", {
                        success: true,
                        couponCode: couponResp.order.couponCode ? couponResp.order.couponCode : "",
                        discount: couponResp.order.couponDiscount ? Math.abs(couponResp.order.couponDiscount) : 0,
                        couponType: "Coupon"
                      });
                    });
                  } else {
                    // Failed to apply coupon code
                    couponModel.isCouponValid = false; // analyticd event

                    this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "applyCoupon", {
                      success: false,
                      couponCode: couponCode ? couponCode : "",
                      discount: 0,
                      couponType: "Coupon"
                    });
                  }
                } else {
                  // Failed to apply coupon code
                  couponModel.isCouponValid = false; // analyticd event

                  this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "applyCoupon", {
                    success: false,
                    couponCode: couponCode ? couponCode : "",
                    discount: 0,
                    couponType: "Coupon"
                  });
                }

                couponModel.isCouponLoading = false;

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function applyCoupon() {
        return _applyCoupon.apply(this, arguments);
      }

      return applyCoupon;
    }()
  }, {
    key: "removeCoupon",
    value: function () {
      var _removeCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var order, couponCode, _yield$handle7, _yield$handle8, err, couponResp, updatedOrder;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                order = this.cartOrder;
                couponCode = order.couponCode;

                if (!couponCode) {
                  _context9.next = 10;
                  break;
                }

                _context9.next = 5;
                return handle(DPServices.Cart.removeCouponCode(couponCode));

              case 5:
                _yield$handle7 = _context9.sent;
                _yield$handle8 = _slicedToArray(_yield$handle7, 2);
                err = _yield$handle8[0];
                couponResp = _yield$handle8[1];

                if (!err) {
                  updatedOrder = couponResp.order;

                  this._processCartResponse(updatedOrder);
                } else {// Failed to remove coupon code
                }

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function removeCoupon() {
        return _removeCoupon.apply(this, arguments);
      }

      return removeCoupon;
    }()
  }, {
    key: "onApplePayAuthorized",
    value: function () {
      var _onApplePayAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(event) {
        var setNewPickupTime,
            payment,
            proceed,
            result,
            success,
            faultCode,
            message,
            _args10 = arguments;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                setNewPickupTime = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : false;
                payment = event.payment;
                this.payment.applePayAuthorization = payment;

                if (!payment) {
                  _context10.next = 21;
                  break;
                }

                proceed = true;

                if (!setNewPickupTime) {
                  _context10.next = 9;
                  break;
                }

                _context10.next = 8;
                return this.setNewPickupTime();

              case 8:
                proceed = _context10.sent;

              case 9:
                if (!proceed) {
                  _context10.next = 18;
                  break;
                }

                _context10.next = 12;
                return this.submitOrder(false);

              case 12:
                result = _context10.sent;
                success = result.status === "SUCCESS";

                if (!success) {
                  this.payment.applePayAuthorization = null;
                  faultCode = result.faultCode;
                  message = this.decodeAuthError(result.reason);

                  if (faultCode && this.isSmartPayFailure(faultCode)) {
                    this.showSmartPayErrorMessage("Apple Pay", FallbackReasonCode.APPLEPAY_DP_FAILURE, message);
                  } else {
                    this.appMessages.showError("Apple Pay", message);
                  }
                }

                return _context10.abrupt("return", success);

              case 18:
                return _context10.abrupt("return", proceed);

              case 19:
                _context10.next = 23;
                break;

              case 21:
                this.appMessages.showError("Apple Pay", "Apple Pay authorization failed. Please try again.");
                return _context10.abrupt("return", false);

              case 23:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function onApplePayAuthorized(_x2) {
        return _onApplePayAuthorized.apply(this, arguments);
      }

      return onApplePayAuthorized;
    }()
  }, {
    key: "decodeAuthError",
    value: function decodeAuthError(reason) {
      if (reason) {
        if (reason === "REQUEST_TIMEOUT") {
          return "Your payment request has been timed out. Please try again.";
        } else {
          return reason;
        }
      } else {
        return reason;
      }
    }
  }, {
    key: "onGooglePayAuthorized",
    value: function () {
      var _onGooglePayAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(payment) {
        var setNewPickupTime,
            proceed,
            result,
            success,
            faultCode,
            _args11 = arguments;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                setNewPickupTime = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : false;
                this.payment.googlePayAuthorization = payment;

                if (!payment) {
                  _context11.next = 34;
                  break;
                }

                proceed = true;

                if (!setNewPickupTime) {
                  _context11.next = 8;
                  break;
                }

                _context11.next = 7;
                return this.setNewPickupTime();

              case 7:
                proceed = _context11.sent;

              case 8:
                if (!proceed) {
                  _context11.next = 31;
                  break;
                }

                _context11.next = 11;
                return this.submitOrder(false);

              case 11:
                result = _context11.sent;
                success = result.status === "SUCCESS";

                if (success) {
                  _context11.next = 28;
                  break;
                }

                this.payment.googlePayAuthorization = null;
                faultCode = result.faultCode;

                if (!(faultCode && this.isSmartPayFailure(faultCode))) {
                  _context11.next = 21;
                  break;
                }

                this.payment.fallbackReasonCode = FallbackReasonCode.GOOGLEPAY_DP_FAILURE;
                return _context11.abrupt("return", {
                  error: {
                    reason: "OTHER_ERROR",
                    message: this.decodeAuthError(result.reason) || "Failed to place order.",
                    intent: "PAYMENT_AUTHORIZATION"
                  },
                  transactionState: "ERROR"
                });

              case 21:
                if (!(faultCode && (faultCode.indexOf("PaymentService") === 0 || faultCode.indexOf("DRI") === 0))) {
                  _context11.next = 25;
                  break;
                }

                return _context11.abrupt("return", {
                  error: {
                    reason: "OTHER_ERROR",
                    message: this.decodeAuthError(result.reason) || "Failed to place order.",
                    intent: "PAYMENT_AUTHORIZATION"
                  },
                  transactionState: "ERROR"
                });

              case 25:
                return _context11.abrupt("return", {
                  transactionState: "SUCCESS"
                });

              case 26:
                _context11.next = 29;
                break;

              case 28:
                return _context11.abrupt("return", {
                  transactionState: "SUCCESS"
                });

              case 29:
                _context11.next = 32;
                break;

              case 31:
                return _context11.abrupt("return", {
                  transactionState: "SUCCESS"
                });

              case 32:
                _context11.next = 36;
                break;

              case 34:
                this.appMessages.showError("Google Pay", "Google Pay authorization failed. Please try again.");
                return _context11.abrupt("return", {
                  transactionState: "ERROR"
                });

              case 36:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function onGooglePayAuthorized(_x3) {
        return _onGooglePayAuthorized.apply(this, arguments);
      }

      return onGooglePayAuthorized;
    }()
  }, {
    key: "payPalSubmitOrder",
    value: function () {
      var _payPalSubmitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(approvalData, deviceData) {
        var processingError, merchantId, _yield$handle9, _yield$handle10, error, _yield$handle11, _yield$handle12, _error;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(approvalData && deviceData)) {
                  _context12.next = 26;
                  break;
                }

                processingError = null;

                if (!this.payment.rsaFlowEnabled) {
                  _context12.next = 12;
                  break;
                } // RSA flow
                // Always use Partial MID for PayPal CORS request


                merchantId = this.sessionAttributes.partialAVSmerchantID;
                _context12.next = 6;
                return handle(this.payment.tokenizePayPalRSA(this.sessionAttributes.paymentCorrelationId, approvalData, deviceData, merchantId, "ToGoRSAToken"));

              case 6:
                _yield$handle9 = _context12.sent;
                _yield$handle10 = _slicedToArray(_yield$handle9, 1);
                error = _yield$handle10[0];

                if (error) {
                  processingError = error;
                }

                _context12.next = 18;
                break;

              case 12:
                _context12.next = 14;
                return handle(this.payment.tokenizePayPal(approvalData, deviceData));

              case 14:
                _yield$handle11 = _context12.sent;
                _yield$handle12 = _slicedToArray(_yield$handle11, 1);
                _error = _yield$handle12[0];

                if (_error) {
                  processingError = _error;
                }

              case 18:
                if (!processingError) {
                  _context12.next = 22;
                  break;
                }

                this.appMessages.showError("PayPal Payment Failed", "PayPal authorization failed. Please try again.");
                _context12.next = 24;
                break;

              case 22:
                _context12.next = 24;
                return this.submitOrder(false);

              case 24:
                _context12.next = 27;
                break;

              case 26:
                this.appMessages.showError("PayPal Payment", "PayPal authorization failed. Please try again.");

              case 27:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function payPalSubmitOrder(_x4, _x5) {
        return _payPalSubmitOrder.apply(this, arguments);
      }

      return payPalSubmitOrder;
    }()
  }, {
    key: "payPalCancel",
    value: function () {
      var _payPalCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(errData) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                Logger.log(errData);

                if (this.payment.fallbackReasonCode === FallbackReasonCode.PAYPAL_DP_FAILURE) {
                  this.showSmartPayErrorMessage("PayPal", FallbackReasonCode.PAYPAL_DP_FAILURE);
                } else {
                  this.appMessages.showError("PayPal", "PayPal payment cancelled. Please try again.");
                }

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function payPalCancel(_x6) {
        return _payPalCancel.apply(this, arguments);
      }

      return payPalCancel;
    }()
  }, {
    key: "payPalErrored",
    value: function () {
      var _payPalErrored = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(errData) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this.payment.payPalErrored = true;
                Logger.log(errData);
                this.showSmartPayErrorMessage("PayPal", FallbackReasonCode.PAYPAL_INIT_FAILURE);

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function payPalErrored(_x7) {
        return _payPalErrored.apply(this, arguments);
      }

      return payPalErrored;
    }()
  }, {
    key: "applePayCancel",
    value: function () {
      var _applePayCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (this.payment.fallbackReasonCode === FallbackReasonCode.APPLEPAY_DP_FAILURE) {
                  this.showSmartPayErrorMessage("Apple Pay", FallbackReasonCode.APPLEPAY_DP_FAILURE);
                } else {
                  this.appMessages.showError("Apple " + (this.payment.requestPhoneNumberFromAppleOrGooglePay ? "Pay" : "pay"), "Apple Pay cancelled. Please try again.");
                }

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function applePayCancel() {
        return _applePayCancel.apply(this, arguments);
      }

      return applePayCancel;
    }()
  }, {
    key: "applePayErrored",
    value: function () {
      var _applePayErrored = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(errData) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                this.payment.applePayErrored = true;
                Logger.log(errData);
                this.showSmartPayErrorMessage("Apple Pay", FallbackReasonCode.APPLEPAY_INIT_FAILURE);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function applePayErrored(_x8) {
        return _applePayErrored.apply(this, arguments);
      }

      return applePayErrored;
    }()
  }, {
    key: "googlePayCancel",
    value: function () {
      var _googlePayCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(reason) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this.payment.fallbackReasonCode === FallbackReasonCode.GOOGLEPAY_DP_FAILURE) {
                  this.showSmartPayErrorMessage("Google Pay", FallbackReasonCode.GOOGLEPAY_DP_FAILURE);
                } else {
                  this.appMessages.showError("Google Pay", "Google Pay cancelled. Please try again.");
                }

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function googlePayCancel(_x9) {
        return _googlePayCancel.apply(this, arguments);
      }

      return googlePayCancel;
    }()
  }, {
    key: "googlePayErrored",
    value: function () {
      var _googlePayErrored = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(errData) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                this.payment.googlePayErrored = true;
                Logger.log(errData);
                this.showSmartPayErrorMessage("Google Pay", FallbackReasonCode.GOOGLEPAY_INIT_FAILURE);

              case 3:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function googlePayErrored(_x10) {
        return _googlePayErrored.apply(this, arguments);
      }

      return googlePayErrored;
    }()
  }, {
    key: "showSmartPayErrorMessage",
    value: function () {
      var _showSmartPayErrorMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(smartPayMethod, fallbackReasonCode) {
        var _this8 = this;

        var message,
            errorMessage,
            _args19 = arguments;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                message = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : "";
                errorMessage = message + " " + i18next.t("label.smart_pay_failure_message", {
                  defaultValue: "Unfortunately, We are unable to process ${0} Payments right now. Would you like to Pay at Restaurant?",
                  interpolation: {
                    prefix: "${",
                    suffix: "}"
                  },
                  0: smartPayMethod
                });
                this.appMessages.showError(smartPayMethod, errorMessage, [], {
                  undismissible: true,
                  okBtnText: "Yes, Place Order",
                  overrideModalProps: {
                    contentClassName: "finalPay"
                  },
                  cancelBtnText: "Cancel",
                  cancelBtnOnClick: function cancelBtnOnClick() {
                    _this8.payment.fallbackReasonCode = "";
                  },
                  okBtnOnClick: function okBtnOnClick() {
                    _this8.payment.fallbackReasonCode = fallbackReasonCode;
                    _this8.payment.activePaymentTab = PaymentMethods.PAY_AT_RESTAURANT;
                    _this8.payment.activeOtherOptionTab = OnlinePaymentTypes.NONE;

                    _this8.submitOrder(false);
                  }
                });

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function showSmartPayErrorMessage(_x11, _x12) {
        return _showSmartPayErrorMessage.apply(this, arguments);
      }

      return showSmartPayErrorMessage;
    }()
  }, {
    key: "isSmartPayFailure",
    value: function isSmartPayFailure(falutCode) {
      var smartPayFailure = false; //Technical Error
      // DRI-100 : service unavailable
      // DRI-102 : Connection Refused - While calling any backend service
      // DRI-103 : Read Timeout - While waiting for response of any backend service
      // DRI-104 : Invalid credentials
      // PaymentService-614 : Transaction is in progress with the service provider

      if (falutCode === "DRI-100" || falutCode === "DRI-102" || falutCode === "DRI-103" || falutCode === "DRI-104" || falutCode.indexOf("PaymentService") === 0 && falutCode === "PaymentService-614") {
        return true;
      }

      return smartPayFailure;
    }
  }, {
    key: "validateOrderDetails",
    value: function validateOrderDetails() {
      if (!this.isOrderDetailsValid) {
        var orderInstructionModel = this.orderInstructionModel,
            pickupInfoModel = this.pickupInfoModel,
            timeModel = this.timeModel;
        this.formState.submitCount = this.formState.submitCount + 1;
        this.rootStore.common.accordionModel.setFormSubmitted();

        if (!timeModel.isValid) {
          timeModel.handleInvalidModel(this.appMessages);
          return false;
        }

        if (!orderInstructionModel.isValid) {
          orderInstructionModel.handleInvalidModel(this.rootStore.isMobile);
          orderInstructionModel.setShowError(true);
          return false;
        }

        if (!pickupInfoModel.isValid) {
          pickupInfoModel.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          orderInstructionModel.setShowError(true);
          return false;
        }

        orderInstructionModel.setShowError(true);
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "validateSubmitOrder",
    value: function validateSubmitOrder() {
      if (!this.isValid) {
        var orderInstructionModel = this.orderInstructionModel,
            pickupInfoModel = this.pickupInfoModel,
            payment = this.payment,
            contactInfoModel = this.contactInfoModel,
            ageConfirmModel = this.ageConfirmModel,
            timeModel = this.timeModel;
        this.formState.submitCount = this.formState.submitCount + 1;
        this.rootStore.common.accordionModel.setFormSubmitted();

        if (!timeModel.isValid) {
          timeModel.handleInvalidModel(this.appMessages);
          return false;
        }

        if (!orderInstructionModel.isValid) {
          orderInstructionModel.handleInvalidModel(this.rootStore.isMobile);
          return false;
        }

        if (!pickupInfoModel.isValid) {
          pickupInfoModel.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          return false;
        }

        if (!payment.isValid) {
          payment.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          return false;
        }

        if (!contactInfoModel.isValid) {
          contactInfoModel.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          return false;
        }

        if (!ageConfirmModel.isValid) {
          ageConfirmModel.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          return false;
        }

        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "processTheProcessingError",
    value: function processTheProcessingError(processingError, errorSource) {
      var _this9 = this;

      var isErrorSourceCheckout = errorSource === "checkout";

      var _getEnvProps2 = getEnvProps(),
          NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_FAILURE_IN_REST_PAYMENT_FALLBACK = _getEnvProps2.NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_FAILURE_IN_REST_PAYMENT_FALLBACK;

      var submitOrderResult = {
        status: "ERROR"
      };

      if (processingError) {
        submitOrderResult.faultCode = "CC_PROCESSING_ERROR";

        if (processingError === ERRORS.CC_TOKENIZATION_TECHNICAL_FAILURE || processingError === ERRORS.ORDER_SESSION_TOKEN_FAILURE) {
          if (toBoolean(NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_FAILURE_IN_REST_PAYMENT_FALLBACK, true)) {
            if (isErrorSourceCheckout) {
              this.payment.allowedPaymentMethods = "BOTH";
            }

            var message = "Unfortunately, We are unable to process Credit / Debit Card Payments right now.";
            var additionalMessage = "";

            if (this.cartOrder.orderType === ORDER_TYPES.TOGO_PICKUP) {
              var part1 = i18next.t("text.checkout.cardPaymentError.message.orderTogo.part1", {
                defaultValue: "Unfortunately, We are unable to process Credit / Debit Card Payments right now."
              });
              var part2 = isErrorSourceCheckout ? i18next.t("text.checkout.cardPaymentError.message.orderTogo.part2", {
                defaultValue: "Would you like to Pay at Restaurant?"
              }) : "";
              message = part1 + part2;
              additionalMessage = isErrorSourceCheckout ? i18next.t("text.checkout.cardPaymentError.additionalMessage.orderTogo", {
                defaultValue: "Please bring your Credit / Debit Card along with you when picking up the order."
              }) : "";
            } else if (this.cartOrder.orderType === ORDER_TYPES.CATERING_DELIVERY || this.cartOrder.orderType === ORDER_TYPES.CATERING_PICKUP) {
              var _part = i18next.t("text.checkout.cardPaymentError.message.orderCatering.part1", {
                defaultValue: "Unfortunately, We are unable to process Credit / Debit Card Payments right now."
              });

              var _part2 = isErrorSourceCheckout ? i18next.t("text.checkout.cardPaymentError.message.orderCatering.part2", {
                defaultValue: "Would you like to Pay at Restaurant?"
              }) : "";

              message = _part + _part2;
              additionalMessage = isErrorSourceCheckout ? i18next.t("text.checkout.cardPaymentError.additionalMessage.orderCatering", {
                defaultValue: "Please bring your Credit / Debit Card along with you when picking up the order."
              }) : "";
            }

            this.appMessages.showError("", message, [additionalMessage], {
              undismissible: false,
              okBtnText: isErrorSourceCheckout ? "Yes, Place Order" : "Ok",
              overrideModalProps: {
                contentClassName: "finalPay"
              },
              okBtnOnClick: function okBtnOnClick() {
                if (isErrorSourceCheckout) {
                  _this9.payment.fallbackReasonCode = processingError === ERRORS.ORDER_SESSION_TOKEN_FAILURE ? FallbackReasonCode.ORDER_SESSION_TOKEN_FAILURE : FallbackReasonCode.CC_TOKENIZATION_FAILURE;
                  _this9.payment.activePaymentTab = PaymentMethods.PAY_AT_RESTAURANT;
                  _this9.payment.activeOtherOptionTab = OnlinePaymentTypes.NONE;

                  _this9.submitOrder(false);
                }
              }
            });
          } else {
            this.appMessages.showError("Credit Card", "Sorry, we're unable to process your request. Please verify card details and re-try or use a different card.");
          }
        } else if (processingError === ERRORS.CVV_VALIDATION_ERROR) {
          this.appMessages.showError("CVV validation", "Sorry, we're unable to process your request. Please verify your Security Code and re-try or use a different card.");
        } else if (processingError === ERRORS.CC_TOKENIZATION_BUSINESS_FAULT) {
          this.appMessages.showError("Credit Card", "Sorry, we're unable to process your request. Please verify card details and re-try or use a different card.");
        } else {
          submitOrderResult.faultCode = "PAYMENT_PROCESSING_ERROR";
          this.appMessages.showError("Checkout", "Cannot proceed with order submission. Please try again.");
        }
      } else {
        submitOrderResult.faultCode = "PAYMENT_PROCESSING_ERROR";
        this.appMessages.showError("Checkout", "Cannot proceed with order submission. Please try again.");
      }

      return submitOrderResult;
    }
  }, {
    key: "getCreditCardTokenizationAttributes",
    value: function getCreditCardTokenizationAttributes(isFullAVSEnabled) {
      return {
        merchantId: isFullAVSEnabled ? this.sessionAttributes.fullAVSmerchantID : this.sessionAttributes.partialAVSmerchantID,
        paymentCorrelationId: this.sessionAttributes.paymentCorrelationId,
        orderId: this.cartOrder.orderId
      };
    } // function is used to tokenize the credit-card number on completing the form

  }, {
    key: "tokenizeCreditCardAndHandleErrors",
    value: function () {
      var _tokenizeCreditCardAndHandleErrors = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var _this$getCreditCardTo, merchantId, orderId, paymentCorrelationId, _yield$handle13, _yield$handle14, processingError;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (this.payment.creditCardInfo.paymentToken) {
                  _context20.next = 8;
                  break;
                }

                _this$getCreditCardTo = this.getCreditCardTokenizationAttributes(this.payment.creditCardInfo.fullAVSEnabled), merchantId = _this$getCreditCardTo.merchantId, orderId = _this$getCreditCardTo.orderId, paymentCorrelationId = _this$getCreditCardTo.paymentCorrelationId;
                _context20.next = 4;
                return handle(this.payment.tokenizeCreditCardPayment(merchantId, paymentCorrelationId, orderId, "TOGO"));

              case 4:
                _yield$handle13 = _context20.sent;
                _yield$handle14 = _slicedToArray(_yield$handle13, 1);
                processingError = _yield$handle14[0];

                if (processingError) {
                  this.processTheProcessingError(processingError, "tokenization");
                }

              case 8:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function tokenizeCreditCardAndHandleErrors() {
        return _tokenizeCreditCardAndHandleErrors.apply(this, arguments);
      }

      return tokenizeCreditCardAndHandleErrors;
    }()
  }, {
    key: "submitOrder",
    value: function () {
      var _submitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(paymentAlreadyProcessed) {
        var _this10 = this;

        var orderInstructionModel, timeModel;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                orderInstructionModel = this.orderInstructionModel, timeModel = this.timeModel;
                return _context22.abrupt("return", new Promise(function (resolve) {
                  runInAction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
                    var _timeModel$currentTim;

                    var valid, orderName, pickDateTime, processingError, guestCount, submitOrderRequest, _this10$orderInstruct, _this10$appAttributes, _this10$appAttributes2, dfpSessionId, canProceedWithSubmitOrder, orderTotal, activePaymentTab, activePaymentOptionTab, inRestaurantPayment, gcPayments, savedCCPayment, merchantId, _yield$handle15, _yield$handle16, error, _this10$getCreditCard, _merchantId, orderId, paymentCorrelationId, _yield$handle17, _yield$handle18, _error2, ccFormPayment, paypalPayment, _applePayment$billing, _applePayment$billing2, _applePayment$shippin, _applePayment$billing3, _applePayment$shippin2, applePayment, phoneNumber, emailAddress, _googlePayment$billin, googlePayAuthorization, googlePaymentPayload, googlePayment, _googlePayment$billin2, _googlePayment$billin3, _googlePayment$billin4, _googlePayment$billin5, _googlePayment$billin6, nameParts, _googlePayment$billin7, _googlePayment$billin8, _inRestaurantPayment, _this10$rootStore, _this10$rootStore$use, resp, userProfile, submitOrderResult, _DPServices$Cart$pars, result, faults, sessionExpiredFaults, paymentServiceFaults, paymentServiceFault;

                    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
                      while (1) {
                        switch (_context21.prev = _context21.next) {
                          case 0:
                            valid = _this10.validateSubmitOrder();
                            orderName = "Order Name " + _this10.cartOrder.orderId;
                            pickDateTime = moment(timeModel === null || timeModel === void 0 ? void 0 : (_timeModel$currentTim = timeModel.currentTimeSlot) === null || _timeModel$currentTim === void 0 ? void 0 : _timeModel$currentTim.startTimeInMs).toDate();
                            processingError = null;

                            if (!valid) {
                              _context21.next = 103;
                              break;
                            }

                            guestCount = orderInstructionModel.guestCount;
                            if (orderInstructionModel.cateringOrderPartysize) guestCount = orderInstructionModel.cateringOrderPartysize;
                            _context21.prev = 7;
                            _this10.formState.apiFiredCount = _this10.formState.apiFiredCount + 1;
                            runInAction(function () {
                              _this10.formState.isSubmitting = true;
                            });
                            submitOrderRequest = {
                              carType: null,
                              carColor: null,
                              legalDrinkingAgeConfirmation: _this10.ageConfirmModel.isAgeConfirmed,
                              paymentAlreadyProcessed: paymentAlreadyProcessed ? true : false,
                              restaurantId: _this10.cartOrder.restaurantId,
                              orderName: orderName,
                              requestedPickupDateTime: pickDateTime,
                              emailId: _this10.contactInfoModel.emailId,
                              pickupName: null,
                              fallbackReasonCode: _this10.payment.fallbackReasonCode,
                              instructions: orderInstructionModel.specialInstructions,
                              firstName: _this10.contactInfoModel.fName,
                              lastName: _this10.contactInfoModel.lName,
                              phoneNumber: _this10.pickupMethodModel.pickupMethod === PickupMethod.CARSIDE ? _this10.pickupInfoModel.curbSideMobile : _this10.contactInfoModel.phoneNumber,
                              phoneType: "Primary",
                              utensils: {
                                noOfGuests: guestCount,
                                heatingKitIncluded: orderInstructionModel.heatingkit ? true : false,
                                silverwareQty: orderInstructionModel.includeSilverware ? guestCount || 1 : 0,
                                plateQty: orderInstructionModel.plates ? guestCount || 1 : 0,
                                bowlsQty: orderInstructionModel.bowls ? guestCount || 1 : 0,
                                butterIncluded: orderInstructionModel.isBreadIncluded ? true : false,
                                cupQty: orderInstructionModel.cups ? guestCount || 1 : 0,
                                iceIncluded: orderInstructionModel.ice ? true : false,
                                silverwareIncluded: orderInstructionModel.isSilverWareShown ? true : false,
                                breadIncluded: orderInstructionModel.isBreadIncluded,
                                condimentsList: orderInstructionModel.selectedCondiments
                              },
                              payments: []
                            };

                            if (_this10.breadSticksModel.isBreadCountEnabled) {
                              submitOrderRequest.totalBreadCount = _this10.breadSticksModel.totalBreadCount;
                            }

                            if (_this10.cartOrder.orderType === ORDER_TYPES.CATERING_DELIVERY) {
                              submitOrderRequest.deliveryOccasion = (_this10$orderInstruct = _this10.orderInstructionModel) === null || _this10$orderInstruct === void 0 ? void 0 : _this10$orderInstruct.occasionSelected;
                              submitOrderRequest.receiverName = _this10.pickupInfoModel.pickupPerson;
                              submitOrderRequest.receiverPhoneNumber = _this10.pickupInfoModel.pickupPersonMobile;
                              submitOrderRequest.deliveryInstruction = _this10.pickupInfoModel.deliveryDriverInfo;
                              delete submitOrderRequest.pickupName;
                            } else {
                              submitOrderRequest.pickupName = _this10.pickupInfoModel.pickupPerson;
                            }

                            if (_this10.pickupMethodModel.pickupMethod === PickupMethod.CARSIDE && (_this10.cartOrder.orderType === ORDER_TYPES.CATERING_PICKUP || _this10.cartOrder.orderType === ORDER_TYPES.TOGO_PICKUP)) {
                              submitOrderRequest.carColor = _this10.pickupInfoModel.vehicleColor;
                              submitOrderRequest.carType = _this10.pickupInfoModel.vehicleType;
                            }

                            if (_this10.contactInfoModel.enableSpecialOffers && _this10.contactInfoModel.splOffer) {
                              submitOrderRequest.emailSignupSource = _this10.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP ? DPServices.Config.getSignUpSource("CHECKOUT").appSource : (_this10$appAttributes = _this10.appAttributes) === null || _this10$appAttributes === void 0 ? void 0 : (_this10$appAttributes2 = _this10$appAttributes.configs) === null || _this10$appAttributes2 === void 0 ? void 0 : _this10$appAttributes2.onlineorder_crm_signup_source;
                              submitOrderRequest.brandOptin = true;

                              if (_this10.contactInfoModel.showDOBFields && _this10.contactInfoModel.isDOBValid) {
                                submitOrderRequest.dobYear = _this10.contactInfoModel.eclubeYear;
                                submitOrderRequest.dobMonth = _this10.contactInfoModel.eclubeMonth;
                                submitOrderRequest.dobDay = _this10.contactInfoModel.eclubeDate;
                              }
                            } else {
                              submitOrderRequest.brandOptin = false;
                            }

                            _context21.next = 17;
                            return _this10.rootStore.platformUtil.getDFPSessionId();

                          case 17:
                            dfpSessionId = _context21.sent;

                            if (dfpSessionId) {
                              submitOrderRequest.bamsCorrelationId = dfpSessionId;
                            }

                            canProceedWithSubmitOrder = true;
                            orderTotal = _this10.payment.orderTotalIncludingGratuity;

                            if (!(orderTotal > 0)) {
                              _context21.next = 63;
                              break;
                            }

                            activePaymentTab = _this10.payment.activePaymentTab;
                            activePaymentOptionTab = _this10.payment.activeOtherOptionTab;

                            if (!(activePaymentTab === PaymentMethods.PAY_AT_RESTAURANT)) {
                              _context21.next = 29;
                              break;
                            }

                            inRestaurantPayment = _this10.payment.payAtRestaurantPayload;
                            submitOrderRequest.payments.push(inRestaurantPayment);
                            _context21.next = 61;
                            break;

                          case 29:
                            // online payment
                            if (_this10.payment.isAnyGiftCardSelected) {
                              gcPayments = _this10.payment.gcPaymentPayload;
                              gcPayments.forEach(function (payment) {
                                return submitOrderRequest.payments.push(payment);
                              });
                            }

                            if (_this10.payment.isSelectedGiftCardsSufficient) {
                              _context21.next = 61;
                              break;
                            }

                            if (!_this10.payment.isSavedCreditCardSelected) {
                              _context21.next = 44;
                              break;
                            } // Saved Credit Card selected


                            savedCCPayment = _this10.payment.savedCCPaymentPayload;

                            if (!(savedCCPayment.creditCard.paymentCVV && _this10.payment.rsaFlowEnabled)) {
                              _context21.next = 41;
                              break;
                            } // CVV validation Callout for RSA flow only
                            // Always use Partial MID for CVV CORS request


                            merchantId = _this10.sessionAttributes.partialAVSmerchantID;
                            _context21.next = 37;
                            return handle(_this10.payment.validateSecurityCode(_this10.sessionAttributes.paymentCorrelationId, _this10.cartOrder.orderId, "TOGO", savedCCPayment, merchantId));

                          case 37:
                            _yield$handle15 = _context21.sent;
                            _yield$handle16 = _slicedToArray(_yield$handle15, 1);
                            error = _yield$handle16[0];

                            if (error) {
                              processingError = error;
                              canProceedWithSubmitOrder = false;
                            }

                          case 41:
                            submitOrderRequest.payments.push(savedCCPayment);
                            _context21.next = 61;
                            break;

                          case 44:
                            if (!(activePaymentOptionTab === OnlinePaymentTypes.CREDIT_CARD)) {
                              _context21.next = 58;
                              break;
                            }

                            if (!_this10.payment.creditCardInfo.isValid) {
                              _context21.next = 57;
                              break;
                            }

                            if (_this10.payment.creditCardInfo.paymentToken) {
                              _context21.next = 54;
                              break;
                            }

                            _this10$getCreditCard = _this10.getCreditCardTokenizationAttributes(_this10.payment.creditCardInfo.fullAVSEnabled), _merchantId = _this10$getCreditCard.merchantId, orderId = _this10$getCreditCard.orderId, paymentCorrelationId = _this10$getCreditCard.paymentCorrelationId;
                            _context21.next = 50;
                            return handle(_this10.payment.tokenizeCreditCardPayment(_merchantId, paymentCorrelationId, orderId, "TOGO"));

                          case 50:
                            _yield$handle17 = _context21.sent;
                            _yield$handle18 = _slicedToArray(_yield$handle17, 1);
                            _error2 = _yield$handle18[0];

                            if (_error2) {
                              processingError = _error2;
                            }

                          case 54:
                            if (!_this10.payment.creditCardInfo.isCCError) {
                              ccFormPayment = _this10.payment.formCCPaymentPayload;
                              submitOrderRequest.payments.push(ccFormPayment);
                            } else {
                              canProceedWithSubmitOrder = false;
                            }

                            _context21.next = 58;
                            break;

                          case 57:
                            canProceedWithSubmitOrder = false;

                          case 58:
                            if (activePaymentOptionTab === OnlinePaymentTypes.PAYPAL) {
                              if (_this10.payment.payPalData && _this10.payment.payPalData.tokenData) {
                                paypalPayment = _this10.payment.payPalPaymentPayload;
                                submitOrderRequest.payments.push(paypalPayment);

                                if (!submitOrderRequest.firstName) {
                                  submitOrderRequest.firstName = paypalPayment.payPalPayment.firstName || " ";
                                }

                                if (!submitOrderRequest.lastName) {
                                  submitOrderRequest.lastName = paypalPayment.payPalPayment.lastName || " ";
                                }

                                if (!submitOrderRequest.phoneNumber) {
                                  submitOrderRequest.phoneNumber = paypalPayment.payPalPayment.phone;
                                }

                                if (!submitOrderRequest.emailId) {
                                  submitOrderRequest.emailId = paypalPayment.payPalPayment.email;
                                }
                              } else {
                                canProceedWithSubmitOrder = false;
                              }
                            }

                            if (activePaymentOptionTab === OnlinePaymentTypes.APPLE_PAY) {
                              if (_this10.payment.applePayAuthorization) {
                                applePayment = _this10.payment.applePayAuthorization;

                                if ((_applePayment$billing = applePayment.billingContact) !== null && _applePayment$billing !== void 0 && _applePayment$billing.countryCode) {
                                  applePayment.billingContact.countryCode = applePayment.billingContact.countryCode.toUpperCase();
                                }

                                submitOrderRequest.payments.push(_this10.payment.applePayPaymentPayload);

                                if (!submitOrderRequest.firstName) {
                                  submitOrderRequest.firstName = applePayment.billingContact.givenName || " ";
                                }

                                if (!submitOrderRequest.lastName) {
                                  submitOrderRequest.lastName = applePayment.billingContact.familyName || " ";
                                }

                                phoneNumber = ((_applePayment$billing2 = applePayment.billingContact) === null || _applePayment$billing2 === void 0 ? void 0 : _applePayment$billing2.phoneNumber) || ((_applePayment$shippin = applePayment.shippingContact) === null || _applePayment$shippin === void 0 ? void 0 : _applePayment$shippin.phoneNumber);
                                emailAddress = ((_applePayment$billing3 = applePayment.billingContact) === null || _applePayment$billing3 === void 0 ? void 0 : _applePayment$billing3.emailAddress) || ((_applePayment$shippin2 = applePayment.shippingContact) === null || _applePayment$shippin2 === void 0 ? void 0 : _applePayment$shippin2.emailAddress);

                                if (phoneNumber && !submitOrderRequest.phoneNumber) {
                                  submitOrderRequest.phoneNumber = phoneNumber;
                                }

                                if (emailAddress && !submitOrderRequest.emailId) {
                                  submitOrderRequest.emailId = emailAddress;
                                }
                              } else {
                                canProceedWithSubmitOrder = false;
                              }
                            }

                            if (activePaymentOptionTab === OnlinePaymentTypes.GOOGLE_PAY) {
                              if (_this10.payment.googlePayAuthorization) {
                                googlePayAuthorization = _this10.payment.googlePayAuthorization;
                                googlePaymentPayload = _this10.payment.googlePayPaymentPayload;
                                submitOrderRequest.payments.push(googlePaymentPayload);
                                googlePayment = googlePaymentPayload.googlePayPayment;

                                if ((_googlePayment$billin = googlePayment.billingInfo) !== null && _googlePayment$billin !== void 0 && _googlePayment$billin.billingAddress) {
                                  if ((_googlePayment$billin2 = googlePayment.billingInfo) !== null && _googlePayment$billin2 !== void 0 && (_googlePayment$billin3 = _googlePayment$billin2.billingAddress) !== null && _googlePayment$billin3 !== void 0 && _googlePayment$billin3.countryCode) {
                                    googlePayment.billingInfo.billingAddress.countryCode = googlePayment.billingInfo.billingAddress.countryCode.toUpperCase();
                                  }

                                  nameParts = extractFromFullName((_googlePayment$billin4 = googlePayment.billingInfo.billingAddress) === null || _googlePayment$billin4 === void 0 ? void 0 : _googlePayment$billin4.name);

                                  if (!submitOrderRequest.firstName) {
                                    submitOrderRequest.firstName = nameParts.first || " ";
                                  }

                                  if (!submitOrderRequest.lastName) {
                                    submitOrderRequest.lastName = nameParts.last || " ";
                                  }

                                  if ((_googlePayment$billin5 = googlePayment.billingInfo) !== null && _googlePayment$billin5 !== void 0 && (_googlePayment$billin6 = _googlePayment$billin5.billingAddress) !== null && _googlePayment$billin6 !== void 0 && _googlePayment$billin6.phoneNumber && !submitOrderRequest.phoneNumber) {
                                    submitOrderRequest.phoneNumber = (_googlePayment$billin7 = googlePayment.billingInfo) === null || _googlePayment$billin7 === void 0 ? void 0 : (_googlePayment$billin8 = _googlePayment$billin7.billingAddress) === null || _googlePayment$billin8 === void 0 ? void 0 : _googlePayment$billin8.phoneNumber;
                                  }
                                }

                                if (googlePayAuthorization.email && !submitOrderRequest.emailId) {
                                  submitOrderRequest.emailId = googlePayAuthorization.email;
                                }
                              } else {
                                canProceedWithSubmitOrder = false;
                              }
                            }

                          case 61:
                            _context21.next = 65;
                            break;

                          case 63:
                            // Order Total is empty. Nothing to Pay.
                            _inRestaurantPayment = _this10.payment.payAtRestaurantPayload;
                            submitOrderRequest.payments.push(_inRestaurantPayment);

                          case 65:
                            if (!canProceedWithSubmitOrder) {
                              _context21.next = 86;
                              break;
                            }

                            _context21.next = 68;
                            return DPServices.Cart.submitOrder(_this10.cartOrder.orderId, submitOrderRequest);

                          case 68:
                            resp = _context21.sent;
                            _context21.next = 71;
                            return _this10.cleanupAfterCheckoutSucess();

                          case 71:
                            resolve({
                              status: "SUCCESS"
                            });

                            if (_this10.contactInfoModel.enableSpecialOffers && _this10.contactInfoModel.splOffer) {
                              _this10.analyticsEclubCheck();
                            }

                            if (!(_this10.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP)) {
                              _context21.next = 76;
                              break;
                            }

                            _context21.next = 76;
                            return handle(_this10.createGeoFence(resp.checkReferencePOS, resp.orderId, submitOrderRequest.emailId));

                          case 76:
                            if ((_this10$rootStore = _this10.rootStore) !== null && _this10$rootStore !== void 0 && (_this10$rootStore$use = _this10$rootStore.user) !== null && _this10$rootStore$use !== void 0 && _this10$rootStore$use.isLoggedIn) {
                              _context21.next = 79;
                              break;
                            }

                            _context21.next = 83;
                            break;

                          case 79:
                            _context21.next = 81;
                            return _this10.rootStore.user.getCurrentUserProfile();

                          case 81:
                            userProfile = _context21.sent;
                            runInAction(function () {
                              _this10.rootStore.user.userProfile = userProfile;
                            });

                          case 83:
                            _this10.redirectToConfirmationPage();

                            _context21.next = 90;
                            break;

                          case 86:
                            runInAction(function () {
                              _this10.formState.isSubmitting = false;
                              _this10.formState.isFailed = true;
                            });
                            submitOrderResult = _this10.processTheProcessingError(processingError, "checkout"); // analytics submit order failed event

                            _this10.analyticsFailedSubmitOrderEvent();

                            resolve(submitOrderResult);

                          case 90:
                            _context21.next = 101;
                            break;

                          case 92:
                            _context21.prev = 92;
                            _context21.t0 = _context21["catch"](7);
                            result = {
                              status: "ERROR"
                            };
                            faults = (_DPServices$Cart$pars = DPServices.Cart.parseErrors(_context21.t0)) === null || _DPServices$Cart$pars === void 0 ? void 0 : _DPServices$Cart$pars.faults;

                            if (faults) {
                              sessionExpiredFaults = faults.filter(function (fault) {
                                return fault.faultCode === "sessionExpired" || fault.faultCode === "SubmitOrderFail";
                              });

                              if (sessionExpiredFaults.length > 0) {
                                sessionExpiredFaults.forEach(function (fault) {
                                  if (fault.faultCode === "sessionExpired") {
                                    result.faultCode = fault.faultCode;
                                    result.reason = fault.faultDescription;

                                    _this10.appMessages.showError("Session Expired", "Your session has expired due to an extended period of inactivity.", null, {
                                      undismissible: true,
                                      okBtnText: "Ok",
                                      okBtnOnClick: function okBtnOnClick() {
                                        _this10.redirectToEmptyCartPage();
                                      }
                                    });
                                  }

                                  if (fault.faultCode === "SubmitOrderFail") {
                                    result.faultCode = fault.faultCode;
                                    result.reason = fault.faultDescription;

                                    _this10.appMessages.showError("Failed", "Failed to submit order. Please re-try.", null, {
                                      undismissible: true,
                                      okBtnText: "Go Back",
                                      okBtnOnClick: function okBtnOnClick() {
                                        _this10.redirectToEmptyCartPage();
                                      }
                                    });
                                  }
                                });
                              } else {
                                paymentServiceFaults = faults.filter(function (fault) {
                                  return fault.faultCode.indexOf("PaymentService-") === 0 || fault.faultCode.indexOf("DRI-") === 0;
                                });

                                if (paymentServiceFaults.length > 0) {
                                  paymentServiceFault = paymentServiceFaults[0];
                                  result.faultCode = paymentServiceFault.faultCode;
                                  result.reason = paymentServiceFault.faultDescription;
                                } else {
                                  _this10.capacityErrorHandle(faults).then(function (handled) {
                                    if (!handled) {
                                      _this10.dialogueCode = CheckoutDialogueCodes.ERROR_CASE_MISSING;
                                      result.faultCode = "ORDER_PROCESSING_ERROR";

                                      _this10.appMessages.showErrorMessage("Oops! Something went wrong...", _context21.t0, null, _this10.dialogueCode);
                                    } else {
                                      result.faultCode = "CAPACITY_ERROR";
                                    }
                                  }, function () {
                                    _this10.dialogueCode = CheckoutDialogueCodes.ERROR_CASE_MISSING;
                                    result.faultCode = "ORDER_PROCESSING_ERROR";

                                    _this10.appMessages.showErrorMessage("Oops! Something went wrong...", _context21.t0, null, _this10.dialogueCode);
                                  });
                                }
                              }
                            } else {
                              result.faultCode = "ORDER_PROCESSING_ERROR";

                              _this10.appMessages.showError("Error", "Unable to proceed with order submission. Please try again.");
                            }

                            _this10.formState.isSubmitting = false;
                            _this10.formState.isFailed = true; // analytics submit order failed event

                            _this10.analyticsFailedSubmitOrderEvent();

                            resolve(result);

                          case 101:
                            _context21.next = 106;
                            break;

                          case 103:
                            _this10.formState.isSubmitting = false;

                            _this10.analyticsFailedSubmitOrderEvent();

                            resolve({
                              status: "ERROR",
                              faultCode: "FORM_INVALID"
                            });

                          case 106:
                          case "end":
                            return _context21.stop();
                        }
                      }
                    }, _callee21, null, [[7, 92]]);
                  })));
                }));

              case 2:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function submitOrder(_x13) {
        return _submitOrder.apply(this, arguments);
      }

      return submitOrder;
    }()
  }, {
    key: "analyticsFailedSubmitOrderEvent",
    value: function analyticsFailedSubmitOrderEvent() {
      this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "Payment", {
        success: false
      });
    }
  }, {
    key: "analyticsEclubCheck",
    value: function analyticsEclubCheck() {
      this.rootStore.platformUtil.dispatchEvent("AnalyticsForm", "eClubOptinComplete", {});
    }
  }, {
    key: "redirectToConfirmationPage",
    value: function redirectToConfirmationPage() {
      var _this11 = this;

      this.rootStore.platformUtil.clearSessionStorage()["finally"](function () {
        if (_this11.rootStore.platformUtil.PLATFORM_TYPE === "APP") {
          var _this11$rootStore, _this11$rootStore$pla;

          (_this11$rootStore = _this11.rootStore) === null || _this11$rootStore === void 0 ? void 0 : (_this11$rootStore$pla = _this11$rootStore.platformUtil) === null || _this11$rootStore$pla === void 0 ? void 0 : _this11$rootStore$pla.navigateToRoute("/commerce/order-confirmation");
        }

        _this11.rootStore.platformUtil.redirectToURL("/commerce/order-confirmation");
      });
    }
  }, {
    key: "redirectToEmptyCartPage",
    value: function redirectToEmptyCartPage() {
      if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
        var _this$sessionAttribut2;

        if ((_this$sessionAttribut2 = this.sessionAttributes) !== null && _this$sessionAttribut2 !== void 0 && _this$sessionAttribut2.cartEmptyURL) {
          this.rootStore.platformUtil.redirectToURL(this.sessionAttributes.cartEmptyURL);
        } else {
          // this.rootStore.refreshInProgress = true;
          this.rootStore.platformUtil.redirectToURL("/order-online?cartEmpty=true");
        }
      } else {
        this.rootStore.reloadApp();
      }
    }
  }, {
    key: "fetchTimes",
    value: function () {
      var _fetchTimes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        var _this$rootStore$user$,
            _this$rootStore$user$2,
            _this12 = this;

        var realtime,
            sessionContext,
            _yield$handle19,
            _yield$handle20,
            timesResponse,
            _args23 = arguments;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                realtime = _args23.length > 0 && _args23[0] !== undefined ? _args23[0] : false;
                sessionContext = (_this$rootStore$user$ = this.rootStore.user.sessionDetails) === null || _this$rootStore$user$ === void 0 ? void 0 : (_this$rootStore$user$2 = _this$rootStore$user$.successResponse) === null || _this$rootStore$user$2 === void 0 ? void 0 : _this$rootStore$user$2.sessionContext;

                if (!sessionContext) {
                  _context23.next = 15;
                  break;
                }

                _context23.prev = 3;
                _context23.next = 6;
                return handle(DPServices.Times.getPickupTimes(this.cartOrder.restaurantId, sessionContext.orderTypeValue, this.timeModel.selectedCalendarDate, //revisit this, send date based on
                realtime, sessionContext.isCapacityCheckEnabled, this.timeModel.isAsapSelected));

              case 6:
                _yield$handle19 = _context23.sent;
                _yield$handle20 = _slicedToArray(_yield$handle19, 2);
                timesResponse = _yield$handle20[1];

                if (timesResponse) {
                  runInAction(function () {
                    var _this12$timeModel, _this12$timeModel$sel;

                    _this12.timeModel.currentRequestedDate = (_this12$timeModel = _this12.timeModel) === null || _this12$timeModel === void 0 ? void 0 : (_this12$timeModel$sel = _this12$timeModel.selectedCalendarDate) === null || _this12$timeModel$sel === void 0 ? void 0 : _this12$timeModel$sel.getTime();

                    _this12.timeModel.setCapacitySlotsResponse(timesResponse);
                  });
                }

                _context23.next = 15;
                break;

              case 12:
                _context23.prev = 12;
                _context23.t0 = _context23["catch"](3);
                this.appMessages.showError("Error", "Error Fetching Time Slots.");

              case 15:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[3, 12]]);
      }));

      function fetchTimes() {
        return _fetchTimes.apply(this, arguments);
      }

      return fetchTimes;
    }()
  }, {
    key: "setNewPickupTime",
    value: function () {
      var _setNewPickupTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var _this13 = this;

        var newSelectedTime, setPickupResponse, handled, unavailableItemsHandled;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.prev = 0;
                newSelectedTime = this.timeModel.currentTimeSlot.startTimeInMs;
                _context24.next = 4;
                return DPServices.Times.setOrderPickupTime(moment(newSelectedTime).toDate(), true, this.timeModel.isAsapSelected);

              case 4:
                setPickupResponse = _context24.sent;
                runInAction(function () {
                  var _this13$timeModel;

                  _this13.timeModel.setTimeModalShown(false);

                  _this13.timeModel.setPickupTimeResponse(setPickupResponse);

                  (_this13$timeModel = _this13.timeModel) === null || _this13$timeModel === void 0 ? void 0 : _this13$timeModel.setRecentTimeSelectionFromAPi(UserTypes.ERecentTimeSelectionFromAPI.SET_PICKUP_TIME_API);

                  _this13.carSideApiHandler();

                  if (!_this13.timeModel.isCapacityError) {
                    _this13.determinePaymentMethods();
                  }
                });
                return _context24.abrupt("return", true);

              case 9:
                _context24.prev = 9;
                _context24.t0 = _context24["catch"](0);
                handled = this.timeModel.submitErrorHandler(this.appMessages, _context24.t0);
                unavailableItemsHandled = this.unavailableItemsModel.submitErrorHandler(this.appMessages, _context24.t0);

                if (!handled) {
                  this.timeModel.setTimeModalShown(false);
                  this.appMessages.showErrorMessage("Error", _context24.t0, {
                    undismissible: true,
                    okBtnText: "Ok",
                    okBtnOnClick: function okBtnOnClick() {
                      _this13.redirectToEmptyCartPage();
                    }
                  });
                }

              case 14:
                return _context24.abrupt("return", false);

              case 15:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this, [[0, 9]]);
      }));

      function setNewPickupTime() {
        return _setNewPickupTime.apply(this, arguments);
      }

      return setNewPickupTime;
    }()
  }, {
    key: "resubmitOrderFromCapacityError",
    value: function () {
      var _resubmitOrderFromCapacityError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        var success;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!this.timeModel.isValid) {
                  _context25.next = 7;
                  break;
                }

                _context25.next = 3;
                return this.setNewPickupTime();

              case 3:
                success = _context25.sent;

                if (success) {
                  this.submitOrder(true);
                }

                _context25.next = 8;
                break;

              case 7:
                this.timeModel.handleInvalidModel(this.appMessages);

              case 8:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function resubmitOrderFromCapacityError() {
        return _resubmitOrderFromCapacityError.apply(this, arguments);
      }

      return resubmitOrderFromCapacityError;
    }()
  }, {
    key: "cancelCapacityError",
    value: function () {
      var _cancelCapacityError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        var _this14 = this;

        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                runInAction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
                  var success, message;
                  return _regeneratorRuntime.wrap(function _callee26$(_context26) {
                    while (1) {
                      switch (_context26.prev = _context26.next) {
                        case 0:
                          _this14.timeModel.isCapacityError = true; //??

                          _this14.timeModel.setTimeModalShown(false);

                          _context26.next = 4;
                          return _this14.setNewPickupTime();

                        case 4:
                          success = _context26.sent;
                          message = _this14.timeModel.isAsapSelected ? i18next.t("text.checkout.cancelCapacityErrorASAP.success.successMessage", {
                            defaultValue: "Your ASAP time has been updated to ".concat(_this14.timeModel.displayDate, "."),
                            interpolation: {
                              prefix: "${",
                              suffix: "}"
                            },
                            0: _this14.timeModel.displayDate
                          }) : i18next.t("text.checkout.cancelCapacityError.success.successMessage", {
                            defaultValue: "Your pickup time has been updated to first available slot."
                          });

                          if (success) {
                            _this14.appMessages.showSuccess("Pickup time updated.", message);

                            _this14.determinePaymentMethods();

                            _this14.timeModel.isCapacityError = false;
                          } else {
                            _this14.appMessages.showError("Pickup time", "Failed to update pickup time.");
                          }

                        case 7:
                        case "end":
                          return _context26.stop();
                      }
                    }
                  }, _callee26);
                })));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));

      function cancelCapacityError() {
        return _cancelCapacityError.apply(this, arguments);
      }

      return cancelCapacityError;
    }()
  }, {
    key: "carSideApiHandler",
    value: function () {
      var _carSideApiHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        var _this$sessionAttribut3, isInRestaurantPickupAvailable, isCurbsideNotificationEnabled, carSidePickupAvailable;

        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _this$sessionAttribut3 = this.sessionAttributes, isInRestaurantPickupAvailable = _this$sessionAttribut3.isInRestaurantPickupAvailable, isCurbsideNotificationEnabled = _this$sessionAttribut3.isCurbsideNotificationEnabled;
                _context28.next = 3;
                return DPServices.Restaurant.checkCarsideAvailable();

              case 3:
                carSidePickupAvailable = _context28.sent;
                this.handleCurbsideAvailability(carSidePickupAvailable, isInRestaurantPickupAvailable, isCurbsideNotificationEnabled);

              case 5:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function carSideApiHandler() {
        return _carSideApiHandler.apply(this, arguments);
      }

      return carSideApiHandler;
    }()
  }, {
    key: "handleCurbsideAvailability",
    value: function handleCurbsideAvailability(isCurbSideToGoAvailable, isInRestaurantPickupAvailable, isCurbsideNotificationEnabled) {
      if (isCurbSideToGoAvailable && isInRestaurantPickupAvailable) {
        // BOTH Available
        this.pickupInfoModel.inRestaurantPickupAvailable = true;
        this.pickupInfoModel.carSidePickupAvailable = true;

        if (!this.pickupMethodModel.pickupMethod) {
          this.pickupMethodModel.pickupMethod = PickupMethod.CARSIDE; // Default to Curbside
        }

        isCurbsideNotificationEnabled ? this.pickupInfoModel.isCurbsideNotificationEnabled = true : this.pickupInfoModel.isCurbsideNotificationEnabled = false;
      } else {
        // Only One Available
        if (isCurbSideToGoAvailable) {
          this.pickupInfoModel.inRestaurantPickupAvailable = false;
          this.pickupMethodModel.pickupMethod = PickupMethod.CARSIDE; // Default to Curbside

          this.pickupInfoModel.carSidePickupAvailable = true;
          isCurbsideNotificationEnabled ? this.pickupInfoModel.isCurbsideNotificationEnabled = true : this.pickupInfoModel.isCurbsideNotificationEnabled = false;
        } else {
          this.pickupInfoModel.inRestaurantPickupAvailable = true;
          this.pickupMethodModel.pickupMethod = PickupMethod.IN_RESTAURANT; // Default to In Restaurant

          this.pickupInfoModel.carSidePickupAvailable = false;
        }
      }
    } //Capacity error handler function

  }, {
    key: "capacityErrorHandle",
    value: function () {
      var _capacityErrorHandle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(faults) {
        var capacityFaults;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (!faults) {
                  _context29.next = 13;
                  break;
                }

                capacityFaults = faults.filter(function (fault) {
                  return fault.faultCode === "OrderService-800" || fault.faultCode === "OrderService-801";
                });

                if (!capacityFaults.length) {
                  _context29.next = 10;
                  break;
                }

                _context29.next = 5;
                return this.fetchTimes(true);

              case 5:
                this.timeModel.isCapacityError = true;
                this.timeModel.setTimeModalShown(true); //dont change order of setters(), popuup should show after turning capacity on

                return _context29.abrupt("return", true);

              case 10:
                return _context29.abrupt("return", false);

              case 11:
                _context29.next = 14;
                break;

              case 13:
                return _context29.abrupt("return", false);

              case 14:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function capacityErrorHandle(_x14) {
        return _capacityErrorHandle.apply(this, arguments);
      }

      return capacityErrorHandle;
    }()
  }, {
    key: "cleanupAfterCheckoutSucess",
    value: function () {
      var _cleanupAfterCheckoutSucess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        var _this$rootStore4, _this$rootStore4$plat;

        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.prev = 0;
                _context30.next = 3;
                return this.rootStore.platformUtil.clearLocalStorage(["ORDER_HISTORY", "FAVORITE_PRODUCTS"]);

              case 3:
                _context30.next = 5;
                return (_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$plat = _this$rootStore4.platformUtil) === null || _this$rootStore4$plat === void 0 ? void 0 : _this$rootStore4$plat.saveInSessionStorage("UPSELL_CHECKOUT_CONFIRMATION", "false");

              case 5:
                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP)) {
                  _context30.next = 12;
                  break;
                }

                _context30.next = 8;
                return this.rootStore.user.updateSession();

              case 8:
                _context30.next = 10;
                return this.rootStore.payment.init();

              case 10:
                _context30.next = 12;
                return this.rootStore.menuList.init();

              case 12:
                _context30.next = 16;
                break;

              case 14:
                _context30.prev = 14;
                _context30.t0 = _context30["catch"](0);

              case 16:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this, [[0, 14]]);
      }));

      function cleanupAfterCheckoutSucess() {
        return _cleanupAfterCheckoutSucess.apply(this, arguments);
      }

      return cleanupAfterCheckoutSucess;
    }()
  }, {
    key: "rateUserVisit",
    value: function () {
      var _rateUserVisit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(params) {
        var _DPServices$User, _yield$handle21, _yield$handle22, err, visitResponse, _DPServices$Cart$pars2, errObj, faults, haveErrorDescription;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.prev = 0;
                _context31.next = 3;
                return handle(DPServices === null || DPServices === void 0 ? void 0 : (_DPServices$User = DPServices.User) === null || _DPServices$User === void 0 ? void 0 : _DPServices$User.rateVisit(params));

              case 3:
                _yield$handle21 = _context31.sent;
                _yield$handle22 = _slicedToArray(_yield$handle21, 2);
                err = _yield$handle22[0];
                visitResponse = _yield$handle22[1];

                if (!err) {
                  _context31.next = 16;
                  break;
                }

                errObj = err;
                faults = (_DPServices$Cart$pars2 = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars2 === void 0 ? void 0 : _DPServices$Cart$pars2.faults;
                haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

                if (!haveErrorDescription) {
                  _context31.next = 15;
                  break;
                }

                throw new Error(haveErrorDescription);

              case 15:
                throw Errors.RATE_USER_VISIT_FAILED;

              case 16:
                return _context31.abrupt("return", visitResponse === null || visitResponse === void 0 ? void 0 : visitResponse.feedbackSubmit);

              case 19:
                _context31.prev = 19;
                _context31.t0 = _context31["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context31.t0.message);
                return _context31.abrupt("return", false);

              case 23:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this, [[0, 19]]);
      }));

      function rateUserVisit(_x15) {
        return _rateUserVisit.apply(this, arguments);
      }

      return rateUserVisit;
    }()
  }, {
    key: "saveOrderDataInLocalStorage",
    value: function () {
      var _saveOrderDataInLocalStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(orderID, custEmail, orderTime) {
        var temp, updatedData, storedData, _this$rootStore5, _this$rootStore5$menu, thresholdTimestamp, updatedDataAfterTimeValidation;

        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                temp = {
                  id: orderID,
                  emailId: custEmail,
                  orderTime: orderTime
                };
                updatedData = [];
                _context32.next = 4;
                return this.rootStore.platformUtil.getFromLocalStorage("RECENT_ORDER_DETAILS").then(JSON.parse);

              case 4:
                storedData = _context32.sent;

                if (storedData) {
                  updatedData = [].concat(_toConsumableArray(storedData), [temp]);
                } else {
                  updatedData = [temp];
                }

                _context32.prev = 6;
                thresholdTimestamp = moment().subtract(6, "months").valueOf();
                updatedDataAfterTimeValidation = updatedData.filter(function (_data) {
                  var orderTimeStamp = _data.orderTime;
                  return orderTimeStamp > thresholdTimestamp;
                });
                _context32.next = 11;
                return this.rootStore.platformUtil.saveInLocalStorage("RECENT_ORDER_DETAILS", JSON.stringify(updatedDataAfterTimeValidation));

              case 11:
                _context32.next = 13;
                return (_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$menu = _this$rootStore5.menuList) === null || _this$rootStore5$menu === void 0 ? void 0 : _this$rootStore5$menu.fetchRecentOrdersFromLocalStorage();

              case 13:
                _context32.next = 18;
                break;

              case 15:
                _context32.prev = 15;
                _context32.t0 = _context32["catch"](6);
                console.log("*** catch", _context32.t0);

              case 18:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this, [[6, 15]]);
      }));

      function saveOrderDataInLocalStorage(_x16, _x17, _x18) {
        return _saveOrderDataInLocalStorage.apply(this, arguments);
      }

      return saveOrderDataInLocalStorage;
    }()
  }, {
    key: "createGeoFence",
    value: function () {
      var _createGeoFence = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(posCheckReference, orderId, email) {
        var _this$rootStore6, _this$rootStore6$rest, _this$rootStore6$rest2;

        var curbsideTogo, _this$rootStore7, _this$rootStore$resta3, _this$rootStore$resta4, _this$rootStore$resta5, _this$rootStore$resta6, _this$cartOrder, _this$rootStore8, _this$rootStore8$rest, _this$rootStore8$rest2, _this$rootStore$resta, _this$rootStore$resta2, latitude, longitude, enableGeoFence, geoFenceLocationRadius, geofences, canGeoFence, isGeoFenceCapable, isGeoFenceAlreadyStarted, isNotificationPermissionGranted, isBackgroundLocationPermisionsGranted;

        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                curbsideTogo = (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$rest = _this$rootStore6.restaurant) === null || _this$rootStore6$rest === void 0 ? void 0 : (_this$rootStore6$rest2 = _this$rootStore6$rest.detail) === null || _this$rootStore6$rest2 === void 0 ? void 0 : _this$rootStore6$rest2.curbsideTogo;

                if (!posCheckReference) {
                  _context33.next = 29;
                  break;
                }

                _context33.next = 4;
                return (_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : _this$rootStore7.platformUtil.saveInLocalStorage("POS_TOKEN", JSON.stringify({
                  checkReference: posCheckReference,
                  orderId: orderId,
                  email: email,
                  curbsideEnabled: curbsideTogo ? "true" : "false"
                }));

              case 4:
                _this$rootStore$resta = (_this$rootStore$resta3 = this.rootStore.restaurant) === null || _this$rootStore$resta3 === void 0 ? void 0 : (_this$rootStore$resta4 = _this$rootStore$resta3.detail) === null || _this$rootStore$resta4 === void 0 ? void 0 : (_this$rootStore$resta5 = _this$rootStore$resta4.address) === null || _this$rootStore$resta5 === void 0 ? void 0 : (_this$rootStore$resta6 = _this$rootStore$resta5.longitudeLatitude) === null || _this$rootStore$resta6 === void 0 ? void 0 : _this$rootStore$resta6.split(","), _this$rootStore$resta2 = _slicedToArray(_this$rootStore$resta, 2), latitude = _this$rootStore$resta2[0], longitude = _this$rootStore$resta2[1];
                enableGeoFence = this.rootStore.menuList.enableGeoFence;
                geoFenceLocationRadius = this.rootStore.menuList.geoFenceLocationRadius;
                geofences = [{
                  latitude: Number(latitude),
                  longitude: Number(longitude),
                  radius: geoFenceLocationRadius,
                  identifier: "".concat((_this$cartOrder = this.cartOrder) === null || _this$cartOrder === void 0 ? void 0 : _this$cartOrder.orderId, ":").concat((_this$rootStore8 = this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : (_this$rootStore8$rest = _this$rootStore8.restaurant) === null || _this$rootStore8$rest === void 0 ? void 0 : (_this$rootStore8$rest2 = _this$rootStore8$rest.detail) === null || _this$rootStore8$rest2 === void 0 ? void 0 : _this$rootStore8$rest2.restaurantInfo)
                }];
                canGeoFence = latitude && longitude && enableGeoFence && curbsideTogo && geoFenceLocationRadius;

                if (!canGeoFence) {
                  _context33.next = 27;
                  break;
                }

                _context33.next = 12;
                return this.rootStore.platformUtil.isGeoFenceCapable();

              case 12:
                isGeoFenceCapable = _context33.sent;
                _context33.next = 15;
                return this.rootStore.platformUtil.isGeoFenceStarted();

              case 15:
                isGeoFenceAlreadyStarted = _context33.sent;
                isNotificationPermissionGranted = this.rootStore.user.pushNotificationPermissionGranted;
                isBackgroundLocationPermisionsGranted = this.rootStore.user.backgroundLocationPermissionGranted;

                if (!(isGeoFenceCapable && isNotificationPermissionGranted && isBackgroundLocationPermisionsGranted)) {
                  _context33.next = 26;
                  break;
                }

                if (!isGeoFenceAlreadyStarted) {
                  _context33.next = 22;
                  break;
                }

                _context33.next = 22;
                return this.rootStore.platformUtil.stopGeoFence();

              case 22:
                _context33.next = 24;
                return this.rootStore.platformUtil.startGeoFence(geofences[0]);

              case 24:
                _context33.next = 27;
                break;

              case 26:
                this.rootStore.showLocationPermissionPopup = true;

              case 27:
                _context33.next = 33;
                break;

              case 29:
                _context33.next = 31;
                return this.rootStore.platformUtil.removeFromLocalStorage("POS_TOKEN");

              case 31:
                _context33.next = 33;
                return this.rootStore.platformUtil.stopGeoFence();

              case 33:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function createGeoFence(_x19, _x20, _x21) {
        return _createGeoFence.apply(this, arguments);
      }

      return createGeoFence;
    }()
  }, {
    key: "dispatchCheckoutEvent",
    value: function dispatchCheckoutEvent() {
      var _this$cartOrder2;

      var cartId = (_this$cartOrder2 = this.cartOrder) === null || _this$cartOrder2 === void 0 ? void 0 : _this$cartOrder2.orderId;
      var payload = {
        "&&events": "event166:".concat(cartId)
      };
      this.analyticsModel.dispatchCheckoutEvent(payload);
    }
  }, {
    key: "isValid",
    get: function get() {
      var orderInstructionModel = this.orderInstructionModel,
          pickupInfoModel = this.pickupInfoModel,
          payment = this.payment,
          contactInfoModel = this.contactInfoModel,
          ageConfirmModel = this.ageConfirmModel,
          timeModel = this.timeModel;
      return ageConfirmModel.isValid && payment.isValid && orderInstructionModel.isValid && pickupInfoModel.isValid && contactInfoModel.isValid && timeModel.isValid;
    }
  }, {
    key: "isOrderDetailsValid",
    get: function get() {
      var orderInstructionModel = this.orderInstructionModel,
          pickupInfoModel = this.pickupInfoModel,
          timeModel = this.timeModel;
      return orderInstructionModel.isValid && pickupInfoModel.isValid && timeModel.isValid;
    }
  }, {
    key: "dialogueCode",
    get: function get() {
      return this._dialogueCode;
    },
    set: function set(_dialogueCode) {
      var _this15 = this;

      runInAction(function () {
        _this15._dialogueCode = _dialogueCode;
      });
    }
  }]);

  return Checkout;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cartOrder", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sessionAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "result", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "setPickResult", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_dialogueCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderDetailsValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderDetailsValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleCurbsideAvailability", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCurbsideAvailability"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dialogueCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dialogueCode"), _class.prototype)), _class);
export { Checkout as default };